import { PureQueryOptions, gql } from '@apollo/client/core'
import { isScreenerDisplayLogicEnabled } from '../../../../constants/featureFlags'
import { AudienceQuestionLogic } from '../../../model/audienceQuestionLogic'
import AUDIENCE_QUESTION_LOGIC from '../fragments/audienceQuestionLogic'
import AUDIENCE_QUESTION_LOGIC_MEMBER from '../fragments/audienceQuestionLogicMember'

export interface AudienceQuestionLogicData {
  draftAudience?: {
    surveyId: string
    members: {
      memberItem: {
        __typename: string
        questionLk?: string
        criterion?: { question: { questionId: string } }
        questionLogic: AudienceQuestionLogic
      }
    }[]
  } | null
}

// Its own query, not a field on the shared audience fragment: that one backs the whole page, and an
// environment whose schema predates the field would reject it there.
export const GET_AUDIENCE_QUESTION_LOGIC = gql`
  query audienceQuestionLogicV2($projectId: ID!, $surveyId: ID!, $waveId: ID) {
    draftAudience: draftAudienceV2(
      projectId: $projectId
      surveyId: $surveyId
      waveId: $waveId
    ) {
      surveyId
      members {
        ...AudienceQuestionLogicMember
      }
    }
  }
  ${AUDIENCE_QUESTION_LOGIC_MEMBER}
  ${AUDIENCE_QUESTION_LOGIC}
`

// For any audience mutation that can remove a question or an option: the backend drops a condition whose
// source is gone, and nothing else re-reads conditions. Empty when off — everyone issues those mutations.
export const audienceQuestionLogicRefetchQueries = (
  projectId: string,
  surveyId: string,
  waveId: string | undefined
): PureQueryOptions[] =>
  isScreenerDisplayLogicEnabled()
    ? [
        {
          query: GET_AUDIENCE_QUESTION_LOGIC,
          context: { clientName: 'questionnaire' },
          variables: { projectId, surveyId, waveId }
        }
      ]
    : []
